import { Component, OnDestroy, OnInit } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "../../service/user.service";
import { ActionService } from "src/app/service/action.service";
import { DatePipe } from "@angular/common";
import {
  Action,
  GetAllActionsQuery,
} from "src/generated/graphql/idea/action/action.graphql";
import {
  ActionInput,
  ActionStatus,
  UpdateActionInput,
} from "src/app/model/action/action";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IdeaService } from "src/app/service/idea.service";
import { GetUsersQuery } from "src/generated/graphql";
import { GetUserByCommitteeQuery } from "src/generated/graphql/users/users.graphql";
import { IdeaStoreService } from "src/app/store/idea.store";
declare var $: any;

@Component({
  selector: "app-actions",
  templateUrl: "./actions.component.html",
  styleUrls: ["./actions.component.scss"],
  providers: [DatePipe],
})
export class ActionsComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  private destroy$ = new Subject<void>();

  actions: Action[] = [];
  comments: {
    id: string;
    comment: string;
    createdAt: Date;
    actionTitle?: string;
  }[] = [];
  urlParams!: { id: string };

  ideaCode!: string;
  ideaTitle!: string;
  comment!: string;
  actionId: string = "";

  quantityActionsCompleted: number = 0;
  totalActions: number = 0;

  actionModel: ActionInput = new ActionInput();
  updateActionInput: UpdateActionInput = new UpdateActionInput();

  isCommentVisible: boolean = false;
  users;

  constructor(
    public router: Router,
    public loading: NgxSpinnerService,
    public translate: TranslateService,
    public route2: ActivatedRoute,
    public userService: UserService,
    private actionService: ActionService,
    private ideaService: IdeaService,
    private ideaStoreService: IdeaStoreService,
    private datePipe: DatePipe,
  ) {
    super(router, loading, translate);
  }

  ngOnInit() {
    this.getUrlParams();
    this.getAllActions();
    this.getAllUsers();
  }

  ngOnDestroy(): void {
    const el = $("#modalAction");
    if (el[0]) {
      el.remove();
    }

    this.destroy$.next();
    this.destroy$.complete();
  }

  reload() {
    window.location.reload();
  }

  getUrlParams() {
    this.route2.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((url: { id: string }) => {
        this.urlParams = url;
      });
  }

  onOpenModal() {
    this.actionModel = new ActionInput();
    this.showModal("modalAction");
  }

  onEditAction(item: Action) {
    const input = {
      id: item.id,
      title: item.title,
      description: item.description,
      status: item.status,
      startDate: item.startDate,
      idea: {
        id: item.idea.id,
        code: item.idea.code,
        title: item.idea.title,
      },
      endDate: this.datePipe.transform(item.endDate, "yyyy-MM-dd"),
      responsibleId: item?.responsible?.id,
    };

    this.actionModel = Object.assign({}, input);
    this.showModal("modalAction");
  }

  onToggleVisibilityActionDescription(item: Action): void {
    item.isDescriptionVisible = !item.isDescriptionVisible;
  }

  onToggleVisibilityActionComments() {
    this.isCommentVisible = !this.isCommentVisible;
  }

  onToggleVisibilityActionStatusModal(item: Action): void {
    item.isStatusModalVisible = !item.isStatusModalVisible;
  }

  transformStatusName(status: "pending" | "in progress" | "done" | "canceled") {
    switch (status) {
      case "pending":
        return "pending";
      case "in progress":
        return "in-progress";
      case "done":
        return "done";
      case "canceled":
        return "canceled";
    }
  }

  setActionModel(item: Action) {
    const input = {
      id: item.id,
      title: item.title,
      description: item.description,
      status: this.actionModel.status,
      startDate: item.startDate,
      idea: {
        id: item.idea.id,
        code: item.idea.code,
        title: item.idea.title
      },
      endDate: (item.endDate as String).split("T")[0],
      responsibleId: item?.responsible?.id,
    };

    this.actionModel = Object.assign({}, input);
  }

  translateStatus(status: string, forPortuguese = true) {
    if (forPortuguese) {
      switch (status) {
        case "pending":
          return "Não iniciado";
        case "in progress":
          return "Em andamento";
        case "done":
          return "Concluido";
        case "canceled":
          return "Cancelado";
      }

      return;
    }

    switch (status) {
      case "Não Iniciado":
        return "pending";
      case "Em andamento":
        return "in progress";
      case "Concluido":
        return "done";
      case "Cancelado":
        return "canceled";
    }
  }

  validateFieldsOfActionModal(): boolean {
    const arrValidateFields = [
      { value: this.actionModel.title, text: "Titulo<br>" },
      { value: this.actionModel.description, text: "Descrição<br>" },
      { value: this.actionModel.status, text: "Status<br>" },
      { value: this.actionModel.responsibleId, text: "Responsável<br>" },
      { value: this.actionModel.endDate, text: "Data de finalização<br>" },
    ];

    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        this.translate.instant("baseComponent.warningAttention"),
        `${this.translate.instant(
          "baseComponent.warningCorrectFields",
        )} <br> ${stringError}`,
      );
      return false;
    }

    return true;
  }

  validateFieldComment(): boolean {
    const arrValidateFields = [
      { value: this.comment, text: "Comentário<br>" },
      { value: this.actionId, text: "Ação<br>" },
    ];

    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        this.translate.instant("baseComponent.warningAttention"),
        `${this.translate.instant(
          "baseComponent.warningCorrectFields",
        )} <br> ${stringError}`,
      );
      return false;
    }

    return true;
  }

  createAction() {
    const isFieldsValid = this.validateFieldsOfActionModal();
    if (!isFieldsValid) return;

    const input = {
      title: this.actionModel.title,
      description: this.actionModel.description,
      status: this.actionModel.status,
      responsibleId: this.actionModel.responsibleId,
      ideaId: this.urlParams?.id,
      startDate: new Date(),
      endDate: this.actionModel.endDate,
    };

    this.actionService
      .createAction({ input })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.closeModal("modalAction");
          this.showMessage("Sucesso", "Ação criada com sucesso", "success");
          this.actionModel = new ActionInput();

          setTimeout(() => {
            this.reload();
          }, 1000);
        },
        error: (error) => {
          this.onError(error);
        },
      });
  }

  createActionComment() {
    const isCommentValid = this.validateFieldComment();
    if (!isCommentValid) return;

    const input = {
      action: { id: this.actionId },
      comment: this.comment,
    };

    this.actionService
      .createActionComment({ input })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.showMessage(
            "Sucesso",
            "Comentário criado com sucesso",
            "success",
          );

          this.comments.unshift({
            id: this.actionId,
            comment: this.comment,
            createdAt: new Date(),
          });

          this.comment = "";
          this.actionId = "";
        },
        error: (error) => {
          this.onError(error);
        },
      });
  }

  updateAction() {
    const isFieldsValid = this.validateFieldsOfActionModal();
    if (!isFieldsValid) return;

    const input = {
      id: this.actionModel.id,
      title: this.actionModel.title,
      description: this.actionModel.description,
      status: this.actionModel.status,
      responsibleId: this.actionModel.responsibleId,
      ideaId: this.actionModel.idea.id,
      startDate: this.actionModel.startDate,
      endDate: this.actionModel.endDate,
    };

    this.actionService
      .updateAction({ input })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.closeModal("modalAction");
          this.showMessage("Sucesso", "Ação atualizada com sucesso", "success");
          this.actionModel = new ActionInput();

          setTimeout(() => {
            this.reload();
          }, 1000);
        },
        error: (error) => {
          this.onError(error);
        },
      });
  }

  updateAllActions() {
    let input = {
      actions: [],
    };

    for (let i = 0; i < this.actions.length; i++) {
      const { id } = this.actions[i];
      input.actions.push({ id, status: "done" });
    }

    this.loading.show();
    this.actionService
      .updateAllActions({ input })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.loading.hide();
          this.showMessage(
            "Sucesso",
            "Todas ações foram atualizadas com sucesso",
            "success",
          );

          setTimeout(() => {
            this.reload();
          }, 1000);
        },
        error: (error) => {
          this.loading.hide();
          this.onError(error);
        },
      });
  }

  updateActionStatus(item: Action, status: string) {
    this.actionModel.status = this.translateStatus(
      status,
      false,
    ) as ActionStatus;

    if (this.actionModel.status === item.status) {
      this.onToggleVisibilityActionStatusModal(item);
      return;
    }

    this.setActionModel(item);
    this.onToggleVisibilityActionStatusModal(item);
    this.updateAction();
  }

  processActionsAndComments() {
    this.ideaCode = this.urlParams?.id && this.actions[0]?.idea?.code;
    this.ideaTitle = this.urlParams?.id && this.actions[0]?.idea?.title;

    this.totalActions = this.actions?.length;

    for (let i = 0; i < this.actions.length; i++) {
      const item = this.actions[i];

      if (item.status === "done") {
        this.quantityActionsCompleted++;
      }

      for (let i = 0; i < item.comments.length; i++) {
        const comment = item.comments[i];
        this.comments.push({
          ...comment,
          actionTitle: item?.title?.slice(0, 50),
        });
      }

      item.isDescriptionVisible = false;
      item.isStatusModalVisible = false;
    }
  }

  getAllActions() {
    this.loading.show();
    this.actionService
      .getAllActions(this.urlParams?.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: GetAllActionsQuery) => {
          this.loading.hide();
          this.actions = response?.getAllActions;
          this.processActionsAndComments();
        },
        error: () => {
          this.loading.hide();
          this.showMessage("Atenção", "Erro ao carregar as ações");
        },
      });
  }

  getAllUsers() {
    const committeeId = this.urlParams?.id ? localStorage.getItem('committeeId') : null
    this.userService
      .getAllUsersByCommittee(committeeId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: GetUserByCommitteeQuery) => {
          this.users = data.getUsersByCommittee;
        },
        error: (error) => {
          this.onError(error);
        },
      });
  }

  deleteAction(id: string) {
    id &&
      this.actionService
        .deleteAction(id, this.urlParams?.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            this.showMessage("Sucesso", "Ação deletada com sucesso", "success");
            this.refreshListActions(id);
          },
          error: (error) => {
            this.onError(error);
          },
        });
  }

  refreshListActions(id: string) {
    this.quantityActionsCompleted = 0;
    const updatedActions = [];
    for (let i = 0; i < this.actions.length; i++) {
      const item = this.actions[i];

      if (item.id === id) {
        continue;
      }

      if (item.status === "done") {
        this.quantityActionsCompleted++;
      }

      updatedActions.push(item);
    }

    this.actions = updatedActions;
    this.totalActions = this.actions?.length;
  }

  convertIdeaToKaizen() {
    this.confirmMessage(
      "Atenção",
      "Tem certeza que deseja converter essa ideia para kaizen?",
      async () => {
        this.loading.show();
        this.ideaService
          .convertIdeaToKaizen({ id: this.urlParams?.id })
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: () => {
              this.loading.hide();
              this.showMessage("Sucesso", "Ideia convertida com", "success");
            },
            error: (error) => {
              this.loading.hide();
              this.onError(error);
            },
          });
      },
    );
  }

  onSave() {
    if (this.actionModel?.id) {
      this.updateAction();
      return;
    }

    this.createAction();
  }
}
